import clsx from "clsx"

import { useState, type FC, type ReactNode } from "react"

import style from "./style.module.scss"

export type HoverMenuOption = {
  value: string
  label: ReactNode
}

type Props = {
  selected: HoverMenuOption | null
  onSelect: (value: HoverMenuOption) => void
  items: Array<HoverMenuOption>
}

const HoverMenu: FC<Props> = ({ selected, onSelect, items }) => {
  const [isOpen, setOpen] = useState(false)

  const handleSelect = (value: HoverMenuOption) => {
    onSelect(value)
    setOpen(false)
  }

  return (
    <div className={style.wrapper} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <div className={style.current}>
        <p>{selected?.label}</p>
        <div className={style.triangle} />
      </div>
      <div className={clsx(style.menu, { [style.open]: isOpen })}>
        <div className={style.inner}>
          {items.length > 0
            ? items.map(el => (
                <div
                  key={el.value}
                  onClick={() => handleSelect(el)}
                  className={clsx(style.menuItem, { [style.active]: el.value === selected?.value })}
                >
                  {el.label}
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  )
}

export default HoverMenu
